import { ComponentType } from 'react';
import { FieldError } from 'react-hook-form';
import { CSSProperties } from 'styled-components';

export enum EVariant {
  PRIORITY = 'priority',
  STATUS = 'status',
  EVENT = 'event',
}

export type TVariant = 'priority' | 'status' | 'event';

export interface IProps {
  width?: string;
  bg?: string;
  variant?: TVariant;
  disabled?: boolean;
  padding?: CSSProperties['padding'];
}

export interface IDropdownProps {
  options: IOption[];
  className?: string;
  name: string;
  defaultValue?: IOption | null;
  badge: TVariant;
  placeholder: string;
  error?: FieldError;
  label?: string;
  width?: string;
  bg?: string;
  required?: boolean;
  onClick?: (val: string) => React.MouseEventHandler | void;
  disabled?: boolean;
  cypressAttribute?: string;
  customOptionRenderer?: (
    option: IOption,
    wrapperComponent: ComponentType<React.HTMLAttributes<HTMLElement>>,
    props: React.HTMLAttributes<HTMLElement> & { key?: string; 'data-cy'?: string }
  ) => React.ReactNode;
}

export interface IOption {
  optionLabel: string;
  value: string;
}

export interface ITitle {
  badge?: TVariant;
  placeholder: string;
  value: any;
}
